<template>
  <div id="thsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'thsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/exit/check/Check.vue